import React      from 'react';
import CSSModules from 'react-css-modules';

import { reduxForm } from 'redux-form';

import Button        from '../Button';
import Input         from '../Input';
import InlineError   from '../InlineError';
import InputGroup    from '../InputGroup';
import InputSection  from '../InputSection';
import Checkbox      from '../Checkbox';
import Label         from '../Label';
import TextArea      from '../TextArea';

import responseFormatter from '../../services/responseFormatter';

import eventRepo from '../../services/events';

class AttendeeForm extends React.Component {

    componentDidMount() {

        if (this.props.mode === 'edit') {

            this.props.initializeForm(this.props.attendee);

        } else if (this.props.mode === 'add') {

            this.props.initializeForm({
                'event_id': this.props.eventId
            });
        }
    }

    _saveAttendee(values) {

        return new Promise((resolve, reject) => {

            function saveSuccess() {

                this.props.submitted();

                resolve();
            }

            function saveFailed(response) {

                reject(responseFormatter.apiErrorsToFormErrors(response.data.errors));
            }

            if (this.props.mode === 'edit') {

                eventRepo.updateAttendee(values)
                    .then(saveSuccess.bind(this), saveFailed);

            } else if (this.props.mode === 'add') {

                eventRepo.addAttendee(values)
                    .then(saveSuccess.bind(this), saveFailed);
            }
        });
    }

    render() {

        const {
            fields: {
                first_name,
                last_name,
                organisation,
                job_title,
                requirements,
                phone,
                email,
                notes,
                provisional_booking,
                cpd
            }, handleSubmit, submitting
        } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._saveAttendee.bind(this)) }>

                <InputSection>

                    {!this.props.isElearning && (
                        <InputGroup>
                            <Checkbox { ...provisional_booking } errors={ provisional_booking.error } />
                            <Label>Provisional Booking</Label>
                            <InlineError errors={ provisional_booking.error } />
                        </InputGroup>
                    )}

                    <InputGroup>
                        <Label isRequired="true">First Name</Label>
                        <Input { ...first_name } errors={ first_name.error } />
                        <InlineError errors={ first_name.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Last Name</Label>
                        <Input { ...last_name } errors={ last_name.error } />
                        <InlineError errors={ last_name.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Organisation</Label>
                        <Input { ...organisation } errors={ organisation.error } />
                        <InlineError errors={ organisation.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Email</Label>
                        <Input { ...email } type="email" errors={ email.error } />
                        <InlineError errors={ email.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Phone Number</Label>
                        <Input { ...phone } type="tel" errors={ phone.error } />
                        <InlineError errors={ phone.error } />
                    </InputGroup>

                    <InputGroup>
                        <Label isRequired="true">Job Title</Label>
                        <Input { ...job_title } errors={ job_title.error } />
                        <InlineError errors={ job_title.error } />
                    </InputGroup>

                    {!this.props.isElearning && (
                        <InputGroup>
                            <Label>Requirements</Label>
                            <TextArea { ...requirements } errors={ requirements.error } />
                            <InlineError errors={ requirements.error } />
                        </InputGroup>
                    )}

                    {this.props.isElearning && (
                        <InputGroup>
                            <Checkbox { ...cpd } errors={ cpd.error } />
                            <Label>CPD</Label>
                            <InlineError errors={ cpd.error } />
                        </InputGroup>
                    )}

                    <InputGroup>
                        <Label>Notes</Label>
                        <TextArea { ...notes } errors={ notes.error } />
                        <InlineError errors={ notes.error } />
                    </InputGroup>

                </InputSection>

                <Button disabled={ submitting }
                        autoWidth="true"
                        type="submit"
                        theme="success">

                    <span>Save</span>

                </Button>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'attendee',
    fields: [
        'id',
        'first_name',
        'last_name',
        'organisation',
        'job_title',
        'requirements',
        'phone',
        'email',
        'notes',
        'event_id',
        'provisional_booking',
        'cpd'
    ]
};

export default reduxForm(reduxFormParams)(CSSModules(AttendeeForm));


// WEBPACK FOOTER //
// ./components/AttendeeForm/index.js